<template>
  <StripBanner :link="$store.state.auth.loggedIn ? '/vendo' : '/valuta-casa'">
    <p v-if="$store.state.auth.loggedIn">
      Vuoi vendere casa? Gratis per te l'Attestato di Prestazione Energetica
      (APE).
    </p>
    <p v-else>
      Vuoi valutare il tuo immobile? Per te c'è il Report Valore Casa
    </p>
  </StripBanner>
</template>

<script>
import StripBanner from '~/components/StripBanner.vue'

export default {
  components: {
    StripBanner,
  },
}
</script>
